module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bind-email"
  }, [_c('form', {
    staticClass: "s-form"
  }, [_c('div', {
    staticClass: "s-form-row"
  }, [_c('label', {
    staticClass: "s-form-label"
  }, [_vm._v("邮箱：")]), _vm._v(" "), _c('div', {
    staticClass: "s-form-info"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-email",
    class: {
      'error': _vm.emailError
    },
    attrs: {
      "type": "email",
      "placeholder": "请输入邮箱地址"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.validEmail]
    }
  })])]), _vm._v(" "), _c('send_code', {
    attrs: {
      "type": _vm.v_type,
      "request": _vm.request(),
      "is_new": 'true'
    },
    on: {
      "revalid": _vm.revalid,
      "errorResult": _vm.errorResult
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-form-btnrow"
  }, [_c('button', {
    staticClass: "s-button submit s-btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("提交")])])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-31862477!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/email/bind_email.vue
// module id = Rc95
// module chunks = 15